var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVirtumedOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 392,
    viewBox: "0 0 236 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.131 195.983L14.8318 79.3429C5.70239 70.6822 0.560547 58.9484 0.560547 46.7257V46.4812C0.735439 5.51768 53.1682 -14.8768 83.7744 14.1434L158.733 85.1749L162.826 96.8738C175.103 131.691 165.554 170.07 138.131 195.983Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.733 85.1748L162.825 96.8737C175.103 131.691 165.519 170.07 138.096 196.017L14.7963 312.657C5.597 321.353 0.455162 333.191 0.525119 345.519C0.73499 386.517 53.1678 406.877 83.774 377.856L206.933 261.147C244.955 225.177 244.955 166.857 206.933 130.888L158.733 85.1748Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 392,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtumedOutlined);
export default __webpack_public_path__ + "static/media/virtumed-outlined.0a1a5171788af345f020fc1791a66e9c.svg";
export { ForwardRef as ReactComponent };